// extracted by mini-css-extract-plugin
export default {"header":"_2Z4HAKQS","timetable":"_1ODo1SU6 scrollable","location":"d0YHGb54"};